import { http } from "@/lib/http";
import type { PagedResponse, Specialty } from "@/models";

export interface SearchProcedure {
    slug: string;
    code: string;
    title: string;
    subscribed: boolean;
    specialties: Specialty[];
}

export interface SearchResultItem {
    type: "procedure" | "specialty";
    procedure?: SearchProcedure;
    specialty?: Specialty;
    label: string;
    slug: string;
}

export async function searchProcedures(
    query: string,
    signal?: AbortSignal,
): Promise<SearchProcedure[]> {
    if (!query.trim()) {
        return [];
    }

    const response = await http.get<PagedResponse<SearchProcedure>>(
        "/search/",
        {
            params: { q: query },
            signal,
        },
    );

    return response.data.results;
}
